const Callback = () => import(/* webpackChunkName: "callback" */ '../Callback');

export default {
  path: '/authentication/:providerName/callback/:organizationId/',
  component: Callback,
  meta: {
    allowAnonymous: true,
  },
};
